import { render, staticRenderFns } from "./contract-visa.vue?vue&type=template&id=4848cd60&scoped=true"
import script from "./contract-visa.vue?vue&type=script&lang=js"
export * from "./contract-visa.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/style-review.css?vue&type=style&index=0&id=4848cd60&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4848cd60",
  null
  
)

export default component.exports